import { APP_TYPE, PARENT_COMPANY, USER } from "../config";
import {
  expandPermissions,
  getDefaultPermissionsForAuthority,
} from "../constants/access-control";

export function setToken(token) {
  if (!token) {
    return localStorage.clear();
  }
  const tok = token.split(".");
  tok.forEach((token, i) => {
    localStorage.setItem(`tok${i}`, token);
  });
  localStorage.setItem("tokeDate", Date());
}

export function getToken() {
  const tok1 = localStorage.getItem("tok0");
  const tok2 = localStorage.getItem("tok1");
  const tok3 = localStorage.getItem("tok2");

  const finalTok = `${tok1}.${tok2}.${tok3}`;

  return finalTok;
}

export function getParentCompany() {
  return localStorage.getItem(PARENT_COMPANY);
}

export function getAppType() {
  return localStorage.getItem(APP_TYPE);
}

export function deleteTokens() {
  localStorage.removeItem("tok0");
  localStorage.removeItem("tok1");
  localStorage.removeItem("tok2");
  localStorage.removeItem("tokeDate");
}

/**
 * Check if user is authorzied to access by role and localStoreage user
 * @param {string} whiteList a string of roles or types seperated by comma
 * @returns {boolean}
 */
export function isAuthorized(whiteList) {
  try {
    const localUser = JSON.parse(localStorage.getItem(USER));
    if (!localUser) return false;
    if (localUser.authority === "superAdmin") return true;

    // Normalize roles list: accepts "owner, admin" or ["owner","admin"]
    const roles = Array.isArray(whiteList)
      ? whiteList
      : String(whiteList || "")
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);

    // Check by authority, explicit role, and type for backward compatibility
    return (
      roles.includes(localUser.authority) ||
      (localUser.role && roles.includes(localUser.role)) ||
      roles.includes(localUser.type)
    );
  } catch {
    return false;
  }
}

/**
 * Permission check backed by localStorage. Used by helpers (menu config,
 * etc.) that run outside React. Returns true for super admins and tenant
 * account holders. When the user has not yet been assigned tenant roles,
 * falls back to their legacy authority defaults so the UI stays usable
 * during the tenant-role rollout.
 *
 * @param {string} permission
 * @returns {boolean}
 */
export function hasStoredPermission(permission) {
  try {
    const localUser = JSON.parse(localStorage.getItem(USER));
    if (!permission) return true;
    if (!localUser) return false;
    if (localUser.authority === "superAdmin") return true;
    if (localUser.accountHolder || localUser.authority === "owner") return true;

    const apiPermissions = localUser?.access?.permissions || [];
    const hasTenantRoles =
      Array.isArray(localUser?.tenantRoles) && localUser.tenantRoles.length > 0;
    const fallback = hasTenantRoles
      ? []
      : getDefaultPermissionsForAuthority(localUser.authority);

    return expandPermissions([...apiPermissions, ...fallback]).includes(
      permission
    );
  } catch {
    return false;
  }
}

export function hasAnyStoredPermission(permissions = []) {
  return permissions.some((permission) => hasStoredPermission(permission));
}

/**
 * Convenience helper for resource-action style checks like
 * `hasStoredPermissionForAction("jobs", "edit")`. Mirrors PERMISSIONS keys
 * (e.g. `jobs.edit`).
 *
 * @param {string} resource e.g. "jobs", "invoices"
 * @param {string} action e.g. "read", "edit", "create", "delete"
 * @returns {boolean}
 */
export function hasStoredPermissionForAction(resource, action) {
  if (!resource || !action) return false;
  return hasStoredPermission(`${resource}.${action}`);
}

export default isAuthorized;
